import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { officeListCustomers } from "@/lib/office.functions";

export const Route = createFileRoute("/_employee/medewerker/office/klanten")({
  head: () => ({
    meta: [{ title: "Klanten — EVG Office" }, { name: "robots", content: "noindex, nofollow" }],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/medewerker/office/klanten" }],
  }),
  component: Customers,
});

function Customers() {
  const list = useServerFn(officeListCustomers);
  const { data } = useQuery({ queryKey: ["office-customers"], queryFn: () => list() });
  const [q, setQ] = useState("");
  const filtered = (data?.customers ?? []).filter((c: any) => {
    if (!q) return true;
    const hay = `${c.full_name ?? ""} ${c.email ?? ""} ${c.city ?? ""} ${c.customer_number ?? ""}`.toLowerCase();
    return hay.includes(q.toLowerCase());
  });

  return (
    <div className="space-y-5">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-2xl font-bold text-slate-900">Klanten</h1>
        <input
          placeholder="Zoek op naam, e-mail of woonplaats…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm sm:w-72"
        />
      </div>

      <div className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200">
        <ul className="divide-y divide-slate-100">
          {filtered.length === 0 && (
            <li className="p-6 text-center text-sm text-slate-500">Geen klanten gevonden.</li>
          )}
          {filtered.map((c: any) => {
            const name = (c.full_name ?? "").trim() || "Naam onbekend";
            return (
              <li key={c.id} className="flex items-center justify-between gap-3 p-4 hover:bg-slate-50/50">
                <div className="min-w-0">
                  <div className="truncate font-medium text-slate-900">{name}</div>
                  <div className="truncate text-xs text-slate-500">
                    {c.city ?? "Woonplaats onbekend"}
                    {c.customer_number ? ` · ${c.customer_number}` : ""}
                  </div>
                </div>
                <Link
                  to="/medewerker/office/klanten/$id"
                  params={{ id: c.id }}
                  className="shrink-0 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
                >
                  Bekijken
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
